export default class FilaFormularioModel {
  constructor({
    filaId = 0,
    formularioId = 0,
    visivelSolicitante = false,
    visivelAgente = false,
    editavelSolicitante = false,
    editavelAgente = false,
    visivelSolicitanteImpressao = false,
    visivelAgenteImpressao = false,
    ordem = 0,
    tipoSecaoId = null,
  } = {}) {
    this.filaId = filaId
    this.formularioId = formularioId
    this.visivelSolicitante = visivelSolicitante
    this.visivelAgente = visivelAgente
    this.editavelSolicitante = editavelSolicitante
    this.editavelAgente = editavelAgente
    this.visivelAgenteImpressao = visivelAgenteImpressao
    this.visivelSolicitanteImpressao = visivelSolicitanteImpressao
    this.ordem = ordem
    this.tipoSecaoId = tipoSecaoId
  }
}
